$(document).ready(function () {
  $(".next-tab-btn").click(function () {
    console.log("change");
    $(this)
      .closest(".collection-tab-slider")
      .find("li.active")
      .next("li")
      .trigger("click");
  });
  $(".prev-tab-btn").click(function () {
    console.log("prev");
    $(this)
      .closest(".collection-tab-slider")
      .find("li.active")
      .prev("li")
      .trigger("click");
  });

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function generateRandomNumber() {
    var randomNumber = getRandomNumber(1, 10);
    $(".product_count").text(randomNumber);
    $(".product-counter-bar-text").text(randomNumber);
    $(".product-counter-bar").attr(
      "style",
      "background:radial-gradient(closest-side,#fdeae7 79%,transparent 80% 100%),conic-gradient(#e9375f " +
        randomNumber * 10 +
        "%,pink 0)!important;"
    );
  }
  generateRandomNumber();
  setInterval(generateRandomNumber, 30000);

  $(".scroll-video").click(function () {
    $("html, body").animate(
      { scrollTop: $(".loox-video-slider-lqd-section").offset().top - 170 },
      800
    );
    return false;
  });
});
